/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warnings_TitleInputs */

const en_us2_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes on this measurement`)
};

const pt_br2_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observações sobre esta medição`)
};

const es_419_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observaciones sobre esta medición`)
};

const pt_pt2_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observações sobre esta medição`)
};

const fr_fr2_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarques sur cette mesure`)
};

const de_de2_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweise zu dieser Messung`)
};

const it_it2_body_assessment_warnings_title = /** @type {(inputs: Body_Assessment_Warnings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note su questa misurazione`)
};

/**
* | output |
* | --- |
* | "Notes on this measurement" |
*
* @param {Body_Assessment_Warnings_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warnings_title = /** @type {((inputs?: Body_Assessment_Warnings_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warnings_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warnings_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_warnings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warnings_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warnings_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warnings_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warnings_title(inputs)
	return en_us2_body_assessment_warnings_title(inputs)
});
export { body_assessment_warnings_title as "body-assessment.warnings_title" }